/**
 * 这里是h5的一些业务逻辑处理
 */
import { request } from '@/common/request.js'
import { isWeChat } from '@/utils/util.js'

import api from '@/common/api.js'
var jweixin = require('jweixin-module');
import wx from "weixin-js-sdk"
export default {
	//初始化sdk配置  
	initJssdk: function(callback, url) {
		// 这是我这边封装的 request 请求工具，实际就是 uni.request 方法。
		let root_url = window.location.href.split('#')[0];
		return request({
			url: api.user.jssdkConfig,
			data: {
				url: root_url
			}
		}).then((res) => {
			if (res.code == 0) {
				uni.setStorageSync('getAppId', res.data.config.appId);
				let sdk = res.data.config;
				jweixin.config({
					debug: sdk.debug,
					appId: sdk.appId,
					timestamp: sdk.timestamp,
					nonceStr: sdk.nonceStr,
					signature: sdk.signature,
					jsApiList: sdk.jsApiList
				});
				//配置完成后，再执行分享等功能
				if (callback) {
					callback(sdk);
				}

			}

		});
	},
	initWeixinsdk: function(callback, url) {
		// 这是我这边封装的 request 请求工具，实际就是 uni.request 方法。
		let root_url = window.location.href.split('#')[0];
		return request({
			url: api.user.jssdkConfig,
			data: {
				url: root_url
			}
		}).then((res) => {
			if (res.code == 0) {
				uni.setStorageSync('getAppId', res.data.config.appId);
				let sdk = res.data.config;
				wx.config({
					debug: sdk.debug,
					appId: sdk.appId,
					timestamp: sdk.timestamp,
					nonceStr: sdk.nonceStr,
					signature: sdk.signature,
					jsApiList: sdk.jsApiList
				});
				//配置完成后，再执行分享等功能
				if (callback) {
					callback(sdk);
				}
	
			}
	
		});
	},
	//在需支付
	pay: function(data, url1, url2) {
		// url = url ? url : '/pages/user/user';
		if (!isWeChat()) {
			return;
		}
		//每需要重新初始化
		jweixin.config({
			debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
			appId: data.appId, // 必填，公众号的唯一标识
			timestamp: data.timestamp, // 必填，生成签名的时间戳
			nonceStr: data.nonceStr, // 必填，生成签名的随机串
			signature: data.signType, // 必填，签名
			jsApiList: [] // 必填，需要使用的JS接口列表
		});

		jweixin.ready(function() {
			jweixin.chooseWXPay({
				// appId: data.appid,
				timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
				nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
				package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
				signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
				paySign: data.paySign, // 支付签名
				success: function(res) {
					// 支付成功后的回调函数
					uni.redirectTo({ url: url1 })
				},
				fail: function(e) {
					uni.showToast({
						title: '支付失败!',
						icon:'none'
					});
					setTimeout((res) => {
						uni.redirectTo({ url: url2 })
					})
				}

			});
		});
	},
	/**  公众号跳转新页面 **/
	initShareUrlNav(data, url) {
		if (!isWeChat()) {
			return;
		}
		let sign = uni.getStorageSync("sign");
		let user = uni.getStorageSync("userInfo") ? JSON.parse(uni.getStorageSync("userInfo")) : {};
		let _url = `${window.location.href.split("#")[0]}#`;
		_url = _url + url;
		if (_url.indexOf('?') == -1) {
			user.user_id ? _url = _url + '?pid=' + user.user_id : '';
		} else {
			user.user_id ? _url = _url + '&pid=' + user.user_id : '';
		}
		this.shareUrl(data, _url);
	},
	//在需要定位页面调用
	location: function(callback) {
		if (!isWeChat()) {
			console.log('不是微信客户端')
			return;
		}
		this.initJssdk(function(res) {
			jweixin.ready(function() {
				console.info('定位ready')
				jweixin.getLocation({
					type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
					success: function(res) {
						callback(res)
					},
					fail: function(res) {
						console.log(res)
					},
				});
			});
		});
	},
	// h5扫码
	scanCode(callback) {
		if (!isWeChat()) {
			uni.showToast({
				title: '请到微信环境使用扫码功能',
				icon: 'none'
			})
			return;
		}
		this.initJssdk(function(res) {
			jweixin.ready(function() {
				jweixin.scanQRCode({
					needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
					scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success: function(res) {
						callback(res)
					}
				});
			});
		});
	}
}
